import { useLocation } from "react-router-dom"
import {
  parseSharedRouteSettings,
  SharedRouteSettings,
} from "@/lib/sharedRouteLink"

/**
 * Every surface of the shared route page derives the sender's settings here
 * rather than receiving them as a prop, so no view can be wired up and then
 * forget to pass them on. The feature flag service is never consulted.
 */
export const useSharedRouteSettings = (): SharedRouteSettings =>
  parseSharedRouteSettings(useLocation().search)
